import { get, post, sess_get, sess_post } from '../utils/HttpRequests';


async function getFinancialsData(params) {
  const response = await new Promise(function (resolve, reject) {
    const session_token = localStorage.getItem('admin-panel-sessionToken');

    sess_get('admin/console/get-registration-statistics', session_token, params).then((resp) => {
      if (resp.data !== undefined && resp.data.success) {
        resolve(resp.data);
      } else {
        resolve(resp);
      }
    })
      .catch((error) => {
        if (Object.keys(error).length > 0 && error?.response?.data?.error?.reason) {
          resolve(error.response.data);
        }
        else {
          resolve({ "success": false, "error": { "code": 1003, "reason": "Something went wrong" } });
        }
      });
  });
  return (response.success !== undefined) ? response : {};
}


async function getPlans() {
  const response = await new Promise(function (resolve, reject) {
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_get('admin/console/get-plans', session_token).then((resp) => {
      if (resp.data !== undefined && resp.data.success) {
        resolve(resp.data);
      } else {
        resolve(resp);
      }
    })
      .catch((error) => {
        if (Object.keys(error).length > 0 && error?.response?.data?.error?.reason) {
          resolve(error.response.data);
        }
        else {
          resolve({ "success": false, "error": { "code": 1003, "reason": "Something went wrong" } });
        }
      });
  });
  return (response.success !== undefined) ? response : {};
}

async function getInsights() {
  const response = await new Promise(function (resolve, reject) {
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_get('admin/console/payments-insights', session_token).then((resp) => {
      if (resp.data !== undefined && resp.data.success) {
        resolve(resp.data);
      } else {
        resolve(resp);
      }
    })
      .catch((error) => {
        if (Object.keys(error).length > 0 && error?.response?.data?.error?.reason) {
          resolve(error.response.data);
        }
        else {
          resolve({ "success": false, "error": { "code": 1003, "reason": "Something went wrong" } });
        }
      });
  });
  return (response.success !== undefined) ? response : {};
}

export {
  getFinancialsData,
  getPlans,
  getInsights
}